import { History } from './_history'
import { TableData } from './_tableData'

export const DataSelector = {
  History,
  TableData,
}
